import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { getPolicyRulesMenuItems } from './helpers'

const PolicyRulesSelector = ({ policyRules = [], value = [], onChange }) => {
  const { t } = useTranslation()

  const handleChange = e => onChange(e.target.value)

  return (
    <div>
      <ComboBox
        menuItems={getPolicyRulesMenuItems(policyRules)}
        value={value}
        multiple
        fullWidth
        label={t('Policy Rules aplicadas')}
        handleChange={handleChange}
        placeholder={t('Policy Rules aplicadas')}
      />
    </div>
  )
}

export default PolicyRulesSelector
